import React, { FC, useState, useEffect } from 'react';
import { Dialog, CopyTextField, Checkbox, MessageBar, Dropdown, Language } from '@eta/components';
import { useTranslation } from 'react-i18next';
import { PrimaryButton, ProgressIndicator, Icon, MessageBarType, IDropdownOption, ActionButton, Spinner, SpinnerSize } from '@fluentui/react';
import { connect, ConnectedProps } from 'react-redux';
import { ReduxState } from '../../../common/reducers';
import { editErpSystem } from '../../Redux/Actions';
import {
    GetRepresentationOfTaxpayerDto,
    UpdateSystemDelegateRequest,
    UpdateSystemDelegateResponseDto,
} from '../../../Services/ClientProxy/clientProxy';

import './RegenerateSecrets.scss';
import { UIHelpers } from '../../../helpers/UIHelpers';

export interface RegenerateSecretsProps {
    hidden: boolean;
    onClose: () => void;
    onSave: (status: boolean) => void;
    erpData: GetRepresentationOfTaxpayerDto;
    currentLanguage: Language;
}

const mapStateToProps = (state: ReduxState) => ({
    lastError: state.taxpayerProfile.lastError,
});

const mapDispatchToProps = {
    dispatchEditErpSystem: editErpSystem,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const RegenerateSecrets: FC<PropsFromRedux & RegenerateSecretsProps> = (
    props: PropsFromRedux & RegenerateSecretsProps
) => {
    const { t } = useTranslation(['resources']);
    const { erpData, dispatchEditErpSystem, hidden, onClose, onSave, lastError,currentLanguage } = props;
    const [currentSecretData, setcurrentSecretData] = useState<UpdateSystemDelegateResponseDto | undefined>();
    const [disableCheckbox, setdisableCheckbox] = useState<boolean>(true);
    const [loading, setloading] = useState<boolean>(false);
    const [error, setError] = useState<string>();

    const [, setclientIDCopied] = useState<boolean>(false);
    const [, setclientSecret1Copied] = useState<boolean>(false);
    const [, setclientSecret2Copied] = useState<boolean>(false);
    const [expiryInYearsLookups, setExpiryInYearsLookups] = useState<number | undefined>(undefined);
    const [OldexpiryInHoursLookups, setOldexpiryInHoursLookups] = useState<number | undefined>(undefined);
    const [OldexpiryInHoursLookupsName, setOldexpiryInHoursLookupsName] = useState<string | undefined>(undefined);
    const [reGenerate, setReGenerate] = useState<boolean>(false);
    const [expireDate, setexpireDate] = useState<Date>();
    const [disableGenerate, setdisableGenerate] = useState<boolean>(true);



    const ExpiryInHours: IDropdownOption[] = [
        { key: 1, text: t('Immediately') },
        { key: 3, text: t('After_2hours') },
        { key: 9, text: t('After_8hours') },
        { key: 25, text: t('After_24hours') },
        { key: 73, text: t('After_72hours') },
    ];

    const ExpiryInYears: IDropdownOption[] = [
        { key: 1, text: t('1 Year') },
        { key: 2, text: t('2 Year') },
        { key: 3, text: t('3 Year') },
    ];

    const setSecret = async () => {
        const response = await dispatchEditErpSystem(
            new UpdateSystemDelegateRequest({
                accountingSystemId: erpData?.taxpayerRepresentationID,
                accountingSystemName: erpData?.profileNamePrimaryLang,
                callbackUrl: erpData?.callbackUrl,
                apiKey: erpData?.apiKey,
                isMainTaxpayerAccountingSystem:
                    erpData?.isMainTaxpayerAccountingSystem,
                clientSecretExpiryInYears: expiryInYearsLookups,
                oldSecretExpirationInHours: (OldexpiryInHoursLookups ?? 0) - 1,
            })
        );
        setcurrentSecretData((await response.payload).response);
        setloading(false);
    };

    const onGenerateSecret = () => {
        setloading(true);
        setdisableGenerate(true);
        setSecret();
        if (expiryInYearsLookups) {
            const date = new Date();
            date.setFullYear(date.getFullYear() + expiryInYearsLookups);
            setexpireDate(date);
        }
    };

    useEffect(() => {
        if (lastError) {
            setError(lastError?.serviceError?.toString());
            setdisableGenerate(false);
        }
    }, [lastError]);

    useEffect(() => {
        if (!hidden) {
            // setloading(true);
            setcurrentSecretData(new UpdateSystemDelegateResponseDto());
            setdisableCheckbox(true);
            setError('');
        }
    }, [hidden]);

    useEffect(() => {
        if (currentSecretData?.clientID) {
            setReGenerate(true);
        }
    }, [currentSecretData?.clientID]);

    useEffect(() => {
        if (OldexpiryInHoursLookups && expiryInYearsLookups)
            setdisableGenerate(false);
    }, [OldexpiryInHoursLookups, expiryInYearsLookups]);

    return (
        <Dialog
            containerClassName={reGenerate ? 'hideDismiss regenerate_dialog' : 'regenerate_dialog'}
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={550}
            title=
            {!reGenerate ? (
                <>
                    <Icon iconName="Undo" />{' '}
                    {t('form.Taxpayer.RegenerateSecrets')}
                </>
            ) : (
                    <>
                        <Icon iconName="SkypeCircleCheck" />{' '}
                        {t('form.erp.secretGenerate')}
                    </>
                )}
            Footer={!reGenerate && (
                <div className="btn_GenerateSecret">
                    <ActionButton className="btn-Generate" onClick={() => onGenerateSecret()} text={t('form.erp.Generate')}
                        disabled={disableGenerate || loading} />
                </div>
            )}
        >
            <div className="container-fluid RegenerateSecrets">
                <MessageBar
                    messageBarType={MessageBarType.blocked}
                    isMultiline={false}
                    onDismiss={() => setError('')}
                    truncated

                >
                    {error}
                </MessageBar>
                {!reGenerate && (
                    <div className="regenerateSecret_Options">
                        <Dropdown
                            label={t('form.erp.CurrentSecretsExpiration')}
                            options={ExpiryInHours ?? []}
                            selectedKey={OldexpiryInHoursLookups}
                            required
                            onChange={(_, option) => {
                                setOldexpiryInHoursLookups(option?.key as number);
                                setOldexpiryInHoursLookupsName(option?.text as string);
                            }}

                        />
                        <Dropdown
                            label={t('form.erp.NewSecretsExpiration')}
                            options={ExpiryInYears ?? []}
                            selectedKey={expiryInYearsLookups}
                            required
                            onChange={(_, option) => {
                                setExpiryInYearsLookups(option?.key as number);
                            }}
                        />
                        {loading && (
                    <div className="spinnerOnButtonCLick">
                        <Spinner
                            size={SpinnerSize.large}
                            label={t('form.TaxPayer.loading')}
                            ariaLive="assertive"
                            labelPosition="bottom"
                        />
                    </div>
                )}
                    </div>
                )
                }

                {reGenerate && (
                    <><div className="heading">
                        <p>{t('form.erp.Secret1')}</p>
                        <br />
                        <div className='contain_RegenerateSecrets'>
                            <span>{`${t('form.erp.secretexpire')} `}</span>
                            <span>{OldexpiryInHoursLookupsName}</span>
                        </div>
                        <div className='contain_RegenerateSecrets'>
                            <span>{`${t('form.erp.newsecretexpire')} `}</span>
                            <span>{UIHelpers.FormatDatePickerValue(expireDate, currentLanguage?.langIso4)}</span>
                        </div>
                        <br />
                    </div><div className="bodyLine first ClientDetails">
                            <CopyTextField
                                label={t('form.erp.ClientID')}
                                value={currentSecretData?.clientID}
                                copiedTitle={t('copied')}
                                onCopy={() => setclientIDCopied(true)} />
                        </div><div className="bodyLine ClientDetails">
                            <CopyTextField
                                label={t('form.erp.ClientSecret1')}
                                value={currentSecretData?.clientSecretOne}
                                copiedTitle={t('copied')}
                                onCopy={() => setclientSecret1Copied(true)} />
                        </div><div className="bodyLine ClientDetails">
                            <CopyTextField
                                label={t('form.erp.ClientSecret2')}
                                value={currentSecretData?.clientSecretTow}
                                copiedTitle={t('copied')}
                                onCopy={() => setclientSecret2Copied(true)} />
                        </div><div className="bodyLine checkbox">
                            <Checkbox
                                onChange={(_, v) => setdisableCheckbox(!v ?? true)} />
                            <span className="checkLabel">
                                {t('form.erp.confirmCheckbox')}
                            </span>
                        </div>
                        <div className="bodyLine btn-addErp doneBtn">
                            {loading ? (
                                <div>
                                    <ProgressIndicator />
                                </div>
                            ) : null}
                            <PrimaryButton
                                onClick={() => onSave(true)}
                                disabled={disableCheckbox}
                            >
                                {t('form.erp.Done')}
                            </PrimaryButton>
                        </div>
                        {loading && (
                    <div className="spinnerOnButtonCLick">
                        <Spinner
                            size={SpinnerSize.large}
                            label={t('form.TaxPayer.loading')}
                            ariaLive="assertive"
                            labelPosition="bottom"
                        />
                    </div>
                )}</>
                )}
            </div>
        </Dialog>
    );
};
export default connector(RegenerateSecrets);